import { render, staticRenderFns } from "./CategoryDeleteItemModal.vue?vue&type=template&id=37f3c1c8&scoped=true"
import script from "./CategoryDeleteItemModal.vue?vue&type=script&lang=js"
export * from "./CategoryDeleteItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f3c1c8",
  null
  
)

export default component.exports